import { AspectRatio, Box, BoxProps, Flex, Skeleton, SkeletonCircle } from '@chakra-ui/react';
import { rem } from 'polished';

export const CollectionSkeleton = (props: BoxProps) => (
  <Box
    bg="gray.2"
    border="1px"
    borderColor="gray.4"
    h="full"
    rounded="radius.28"
    overflow="hidden"
    {...props}
  >
    <Box pos="relative" mb="space.4">
      <AspectRatio ratio={1.4}>
        <Skeleton rounded="none" />
      </AspectRatio>
      <Box
        boxSize={rem(56)}
        bottom="space.-28"
        right="space.8"
        position="absolute"
        border="1px solid"
        borderColor="gray.4"
        rounded="full"
      >
        <SkeletonCircle boxSize="100%" />
      </Box>
    </Box>
    <Flex flexDir="column" gap="space.8" p="space.16">
      <Skeleton h={rem(16)} w="50%" />
      <Skeleton h={rem(16)} mt="space.10" />
      <Skeleton h={rem(16)} />
      <Skeleton h={rem(16)} w="80%" />
      <Flex mt="space.28" gap="space.24">
        <Flex flexDir="column" w="20%" gap="space.8">
          <Skeleton h={rem(16)} />
          <Skeleton h={rem(16)} />
        </Flex>
        <Flex flexDir="column" w="20%" gap="space.8">
          <Skeleton h={rem(16)} />
          <Skeleton h={rem(16)} />
        </Flex>
      </Flex>
    </Flex>
  </Box>
);
